import { Routes } from '@angular/router';

import { AccordExtractionComponent } from './accord-extraction/accord-extraction.component';
import { GestionAutorisationsComponent } from './gestion-autorisations.component';

export const GESTION_AUTORISATIONS_ROUTES: Routes = [
  {
    path: '',
    component: GestionAutorisationsComponent,
    children: [
      {
        path: '',
        redirectTo: 'accord-extraction',
        pathMatch: 'full'
      },
      {
        path: 'accord-extraction',
        component: AccordExtractionComponent
      }
    ]
  }
];
